{
	"title": "Acceso denegado (403)",
	"description": "No tienes los derechos necesarios para acceder a esta página. Asegúrese de haber iniciado sesión en una cuenta con los permisos adecuados. Borrar los datos de su navegador también podría resolver el problema. Si aún necesita acceso, póngase en contacto con el administrador del sistema.",
	"secondaryButtonTitle": "Cerrar sesión"
}
